import React, { ReactNode, useEffect, useState } from "react";

import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import { colors } from "@zapalacorp/tokens";

interface TextFieldInputProps {
  label?: string;
  placeholder?: string;
  initialValue?: string;
  onChange?: (value: string) => void | Function;
  helperText?: string;
  required?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  disabled?: boolean;
  sx?: object;
}
const TextFieldInputComponent = (props: TextFieldInputProps) => {
  const {
    label = "",
    placeholder = "",
    onChange,
    helperText = "",
    required = false,
    initialValue = "",
    leftIcon,
    rightIcon,
    disabled = false,
    sx,
  } = props;
  const [valueInput, setInputValue] = useState<string>(initialValue || "");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (helperText) {
      setError(true);
    } else {
      setError(false);
    }
  }, [helperText]);

  const renderLabel = () => {
    if (label) {
      return (
        <>
          <InputLabel>
            <span
              style={{
                fontFamily: "Manrope",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "20px",
                letterSpacing: "0.1px",
                // PRIORITY IS CHECK COLOR OF DISABLE AFTER WILL CHECK COLOR ERROR
                // eslint-disable-next-line no-nested-ternary
                color: disabled ? colors.gray400 : error ? colors.error500 : colors.brandBlue600,
              }}
            >
              <span>{label}</span>
              {required && (
                <span
                  style={{
                    marginLeft: "1px",
                    color: "red",
                  }}
                >
                  *
                </span>
              )}
            </span>
          </InputLabel>
        </>
      );
    }
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        {renderLabel()}
        <TextField
          error={error}
          onChange={(event) => {
            const value = event?.target?.value;

            setInputValue(value);
            onChange?.(value);
          }}
          value={valueInput}
          variant="outlined"
          placeholder={placeholder}
          helperText={helperText}
          sx={{
            width: "100%",
            ".MuiOutlinedInput-root": {
              width: "100%",
            },
            "& .Mui-disabled": {
              backgroundColor: colors.gray25,
              borderColor: colors.gray25,
            },
            "& .MuiOutlinedInput-input": {
              padding: "0px",
              paddingLeft: "16px",
              paddingRight: "16px",
              minHeight: "32px",
              height: "40px",
              borderColor: colors.gray300,
              borderRadius: "8px",
              fontFamily: "Manrope",
              fontWeight: "400",
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.25px",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.gray400,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.brandBlue500,
              },
            },
            "& .MuiFormHelperText-root.Mui-error": {
              color: colors.error600,
              margin: "0",
              display: "flex",
              fontSize: "14px",
              fontStyle: "normal",
              alignItems: "center",
              fontFamily: "Manrope",
              fontWeight: "normal",
              lineHeight: "24px",
            },
            ...sx,
          }}
          InputProps={{
            startAdornment: leftIcon ? (
              <InputAdornment position="start">{leftIcon}</InputAdornment>
            ) : undefined,
            endAdornment: rightIcon ? (
              <InputAdornment position="end">{rightIcon}</InputAdornment>
            ) : undefined,
          }}
        />
      </div>
    </>
  );
};

export default TextFieldInputComponent;
